import { useEffect, useRef } from "react";
import SmilesDrawer from "smiles-drawer";

const MOL_W = 300;
const MOL_H = 240;

export function MoleculeCanvas({ smiles }: { smiles: string }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    const drawer = new SmilesDrawer.Drawer({
      width: MOL_W,
      height: MOL_H,
      padding: 16,
    });
    SmilesDrawer.parse(
      smiles,
      (tree) => {
        if (canvasRef.current)
          drawer.draw(tree, canvasRef.current, "light", false);
      },
      () => {},
    );
  }, [smiles]);

  return (
    <canvas
      ref={canvasRef}
      aria-label="Molecule structure"
      width={MOL_W}
      height={MOL_H}
      className="block rounded-xl"
    />
  );
}
